import { WikiNavItem } from "./types"

export const HELP_CENTER_NAVIGATION: WikiNavItem[] = [
  {
    id: "overview",
    label: "Overview",
    type: "top-level",
    path: "/help-center",
    searchKeywords: ["introduction", "welcome", "start", "home"],
  },
  {
    id: "getting-started",
    label: "Getting Started",
    type: "section",
    path: "/help-center/getting-started",
    searchKeywords: [
      "setup",
      "begin",
      "first steps",
      "quickstart",
      "guide",
      "download",
      "applications",
    ],
    children: [
      {
        id: "getting-started-applications",
        label: "Stream Applications",
        type: "sub-item",
        anchorId: "stream-applications",
      },
      {
        id: "getting-started-oracle",
        label: "Oracle Integration Files",
        type: "sub-item",
        anchorId: "oracle-integration",
      },
    ],
  },
  {
    id: "pos-configuration",
    label: "POS Configuration Guide",
    type: "subsection",
    searchKeywords: ["point of sale", "integration", "pos", "configuration"],
    children: [
      {
        id: "oracle",
        label: "Oracle Setup",
        type: "step-list",
        path: "/help-center/pos-configuration/oracle",
        searchKeywords: ["oracle", "micros", "simphony"],
        children: [
          {
            id: "oracle-overview",
            label: "Overview",
            type: "sub-item",
            anchorId: "overview",
          },
          {
            id: "oracle-stream-extension",
            label: "EMC · Stream Extension",
            type: "sub-item",
            anchorId: "stream-extension-app",
          },
          {
            id: "oracle-dual-lane",
            label: "EMC · Dual-Lane",
            type: "sub-item",
            anchorId: "duo-lane-configuration",
          },
          {
            id: "oracle-menu-app",
            label: "Menu App · Oracle",
            type: "sub-item",
            anchorId: "stream-editor-setup",
          },
        ],
      },
      {
        id: "clover",
        label: "Clover Setup",
        type: "step-list",
        path: "/help-center/pos-configuration/clover",
        searchKeywords: ["clover", "fiserv"],
        children: [
          {
            id: "clover-overview",
            label: "Overview",
            type: "sub-item",
            anchorId: "overview",
          },
          {
            id: "clover-stream-editor",
            label: "Stream-Editor Setup",
            type: "sub-item",
            anchorId: "stream-editor",
          },
          {
            id: "clover-pos-station",
            label: "POS Station Setup",
            type: "sub-item",
            anchorId: "pos-station",
          },
          {
            id: "clover-pos-settings",
            label: "POS Station Settings",
            type: "sub-item",
            anchorId: "pos-settings",
          },
        ],
      },
      {
        id: "focus",
        label: "Focus Setup",
        type: "step-list",
        path: "/help-center/pos-configuration/focus",
        searchKeywords: ["focus", "focus pos"],
      },
      {
        id: "table-needs",
        label: "Table Needs Setup",
        type: "step-list",
        path: "/help-center/pos-configuration/table-needs",
        searchKeywords: ["table needs", "table management"],
      },
      {
        id: "cbs-north-star",
        label: "CBS North Star Setup",
        type: "step-list",
        path: "/help-center/pos-configuration/cbs-north-star",
        searchKeywords: ["cbs", "north star", "northstar"],
      },
    ],
  },
  {
    id: "ocb-app",
    label: "OCB App",
    type: "top-level",
    searchKeywords: ["ocb", "application", "app"],
  },
  {
    id: "pos-integrations",
    label: "POS Integrations",
    type: "section",
    searchKeywords: ["pos", "integration", "link", "connect"],
  },
  {
    id: "linking-pos-devices",
    label: "Linking POS Devices",
    type: "subsection",
    searchKeywords: ["link", "connect", "device", "pos"],
    children: [
      {
        id: "linking-oracle",
        label: "Oracle",
        type: "step-list",
        path: "/help-center/linking-pos-devices/oracle",
        searchKeywords: ["oracle", "micros", "simphony"]
      },
      {
        id: "linking-clover",
        label: "Clover",
        type: "step-list",
        path: "/help-center/linking-pos-devices/clover",
        searchKeywords: ["clover"]
      },
      {
        id: "linking-focus",
        label: "Focus",
        type: "step-list",
        path: "/help-center/linking-pos-devices/focus",
        searchKeywords: ["focus"]
      },
      {
        id: "linking-table-needs",
        label: "Table Needs",
        type: "step-list",
        path: "/help-center/linking-pos-devices/table-needs",
        searchKeywords: ["table needs"]
      },
      {
        id: "linking-cbs",
        label: "CBS North Star",
        type: "step-list",
        path: "/help-center/linking-pos-devices/cbs-north-star",
        searchKeywords: ["cbs", "north star"]
      }
    ]
  },
  {
    id: "required-downloads",
    label: "Required Downloads",
    type: "special",
    icon: "download",
    searchKeywords: ["download", "files", "applications"]
  }
]
